(function(){
  // Mega menu toggle
  var nc = document.getElementById('navCats');
  if (nc) {
    var btn = nc.querySelector('.nav-cats-btn');
    var open = false;
    function set(v){ open=v; nc.classList.toggle('open',v); btn.setAttribute('aria-expanded',v); }
    btn.addEventListener('click', function(e){ e.stopPropagation(); set(!open); });
    nc.addEventListener('mouseenter', function(){ set(true); });
    nc.addEventListener('mouseleave', function(){ set(false); });
    document.addEventListener('click', function(){ set(false); });
  }

  // Hero slider
  var slider = document.getElementById('heroSlider');
  if (slider) {
    var slides = slider.querySelectorAll('.hero-slide');
    var dots = slider.querySelectorAll('.hero-dots button');
    var i = 0, n = slides.length;
    function go(k){ i=k; slides.forEach(function(s,x){ s.classList.toggle('active',x===k); }); dots.forEach(function(d,x){ d.classList.toggle('active',x===k); }); }
    dots.forEach(function(d){ d.addEventListener('click', function(){ go(+d.dataset.i); }); });
    if (n > 1) setInterval(function(){ go((i+1)%n); }, 4800);
  }

  // Product tabs (homepage)
  var pt = document.getElementById('ptabs');
  if (pt) {
    var tabs = pt.querySelectorAll('.tab');
    var panes = document.querySelectorAll('.tab-pane');
    tabs.forEach(function(t){ t.addEventListener('click', function(){
      var k = t.dataset.tab;
      tabs.forEach(function(x){ x.classList.toggle('active', x===t); });
      panes.forEach(function(p){ p.classList.toggle('active', p.dataset.pane===k); });
    }); });
  }

  // Countdown timers (daily reset / fixed end date / fixed hours)
  document.querySelectorAll('.deal-timer').forEach(function(tm){
    var end = 0;
    if (tm.dataset.end) {
      var d = new Date(tm.dataset.end.replace(' ', 'T'));
      if (!isNaN(d.getTime())) end = d.getTime();
    }
    if (!end && tm.dataset.daily === 'true') {
      var mid = new Date();
      mid.setHours(24, 0, 0, 0);
      end = mid.getTime();
    }
    if (!end) {
      var hours = parseInt(tm.dataset.hours || '10', 10);
      end = Date.now() + hours*3600*1000;
    }
    function pad(x){ return String(x).padStart(2,'0'); }
    function tick(){
      var diff = Math.max(0, Math.floor((end - Date.now())/1000));
      var h = Math.floor(diff/3600), m = Math.floor((diff%3600)/60), s = diff%60;
      tm.querySelector('[data-h]').textContent = pad(h);
      tm.querySelector('[data-m]').textContent = pad(m);
      tm.querySelector('[data-s]').textContent = pad(s);
    }
    tick(); setInterval(tick, 1000);
  });

  // Product gallery thumbnails
  document.querySelectorAll('.gallery').forEach(function(g){
    var main = g.querySelector('#mainImg');
    g.querySelectorAll('.thumb').forEach(function(t){
      t.addEventListener('click', function(){
        if (main) main.src = t.dataset.src;
        g.querySelectorAll('.thumb').forEach(function(x){ x.classList.toggle('active', x===t); });
      });
    });
  });

  // Product variant selection
  var form = document.getElementById('addForm');
  if (form) {
    var sel = document.getElementById('variantSelect');
    var addBtn = form.querySelector('.btn-yellow.big');
    var buyBtn = document.getElementById('buyNowBtn');
    function currentOptions(){ return Array.from(form.querySelectorAll('.pi-option')).map(function(o){ var c=o.querySelector('input:checked'); return c?c.value:null; }); }
    function syncVariant(){
      if (!sel) return;
      var vals = currentOptions().join(' / ');
      var matched = null;
      Array.from(sel.options).forEach(function(op){
        var title = op.textContent.split(' - ')[0].trim();
        if (title === vals) matched = op;
      });
      if (matched) {
        sel.value = matched.value;
        var out = matched.disabled;
        if (addBtn) { addBtn.disabled = out; addBtn.textContent = out ? 'Sold Out' : 'Add to Cart'; }
        if (buyBtn) buyBtn.disabled = out;
      }
    }
    form.querySelectorAll('.pi-swatches input').forEach(function(r){
      r.addEventListener('change', syncVariant);
    });
    // Buy Now -> straight to checkout; Add to Cart -> cart page
    var returnTo = document.getElementById('returnTo');
    if (buyBtn && returnTo) buyBtn.addEventListener('click', function(){ returnTo.value = '/checkout'; });
    if (addBtn && returnTo) addBtn.addEventListener('click', function(){ returnTo.value = '/cart'; });
    // qty
    var qi = document.getElementById('qtyInput');
    var qm = form.querySelector('.qminus'), qp = form.querySelector('.qplus');
    if (qm) qm.addEventListener('click', function(){ qi.value = Math.max(1, (+qi.value)-1); });
    if (qp) qp.addEventListener('click', function(){ qi.value = (+qi.value)+1; });
  }

  // Cart qty +/- (submit form on change)
  document.querySelectorAll('.cart-qty input').forEach(function(inp){
    inp.addEventListener('change', function(){
      var key = inp.dataset.key, q = inp.value;
      window.location.href = '/cart/change?id=' + key + '&quantity=' + q;
    });
  });
  document.querySelectorAll('.qty-adj').forEach(function(a){
    a.addEventListener('click', function(e){ e.preventDefault(); var k=a.dataset.key, q=a.dataset.q; window.location.href='/cart/change?id='+k+'&quantity='+q; });
  });

  // Mobile drawer
  var mt = document.getElementById('mobileToggle');
  var drawer = document.getElementById('mobileDrawer');
  var overlay = document.getElementById('mobileOverlay');
  var mdClose = document.getElementById('mdClose');
  function openDrawer(v){ if(!drawer) return; drawer.classList.toggle('open',v); if (overlay) overlay.classList.toggle('open',v); if(mt) mt.setAttribute('aria-expanded',v); document.body.style.overflow = v ? 'hidden' : ''; }
  if (mt) mt.addEventListener('click', function(){ openDrawer(!drawer.classList.contains('open')); });
  if (mdClose) mdClose.addEventListener('click', function(){ openDrawer(false); });
  if (overlay) overlay.addEventListener('click', function(){ openDrawer(false); });

  // Collection filter drawer (mobile)
  var sidebar = document.getElementById('shopSidebar');
  var fOpen = document.getElementById('filterOpen');
  var fClose = document.getElementById('filterClose');
  var fApply = document.getElementById('filterApply');
  var fOverlay = document.getElementById('filterOverlay');
  if (sidebar && fOpen) {
    function setFilters(v){
      sidebar.classList.toggle('open', v);
      if (fOverlay) fOverlay.classList.toggle('open', v);
      fOpen.setAttribute('aria-expanded', v);
      document.body.classList.toggle('no-scroll', v);
    }
    fOpen.addEventListener('click', function(){ setFilters(!sidebar.classList.contains('open')); });
    if (fClose) fClose.addEventListener('click', function(){ setFilters(false); });
    if (fApply) fApply.addEventListener('click', function(){ setFilters(false); });
    if (fOverlay) fOverlay.addEventListener('click', function(){ setFilters(false); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') setFilters(false); });
    // desktop par wapas aane par drawer state reset
    window.addEventListener('resize', function(){
      if (window.innerWidth > 820 && sidebar.classList.contains('open')) setFilters(false);
    });
  }

  // ---- Category filter + Load More ("Recommended for You" grid) ----
  // Chips asli <a> links hain, is liye JS band ho to bhi collection page
  // khul jata hai. JS on ho to grid usi jagah swap ho jata hai.
  document.querySelectorAll('[data-loadmore]').forEach(function(box){
    var grid = box.querySelector('[data-loadmore-grid]');
    if (!grid) return;

    var wrap    = box.querySelector('[data-loadmore-wrap]');
    var btn     = box.querySelector('[data-loadmore-btn]');
    var txt     = btn && btn.querySelector('.lm-txt');
    var shownEl = box.querySelector('[data-lm-shown]');
    var totalEl = box.querySelector('[data-lm-total-txt]');
    var chips   = box.querySelectorAll('[data-catchip]');

    var base  = box.dataset.lmBase || '/';
    var page  = parseInt(grid.dataset.lmPage  || '1', 10);
    var total = parseInt(grid.dataset.lmTotal || '0', 10);
    var size  = parseInt(grid.dataset.lmSize  || '0', 10);
    var busy  = false;

    function urlFor(p){
      return base + (base.indexOf('?') > -1 ? '&' : '?') + 'view=loadmore&page=' + p;
    }
    function count(){ return grid.querySelectorAll('.pcard').length; }

    function sync(){
      var n = count();
      if (shownEl) shownEl.textContent = n;
      if (totalEl) totalEl.textContent = total || n;
      if (!btn) return;
      if (total && n < total) {
        btn.removeAttribute('hidden');
        btn.setAttribute('href', urlFor(page + 1));
      } else {
        btn.setAttribute('hidden', '');
      }
    }

    function done(){
      busy = false;
      grid.classList.remove('is-swapping');
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    }

    // replace = true  -> category badli, grid poora naya
    // replace = false -> Load More, cards neeche append
    function load(p, replace){
      if (busy) return;
      busy = true;
      if (btn) {
        btn.classList.remove('is-error');
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
      }
      if (txt) txt.textContent = 'Loading…';
      if (replace) grid.classList.add('is-swapping');

      fetch(urlFor(p), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
        .then(function(r){ if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector('[data-loadmore-grid]');
          var cards = (src || doc).querySelectorAll('.pcard');

          if (src) {
            if (src.dataset.lmTotal) total = parseInt(src.dataset.lmTotal, 10);
            if (src.dataset.lmSize)  size  = parseInt(src.dataset.lmSize, 10);
          }

          if (replace) grid.innerHTML = '';

          if (!cards.length) {
            if (replace) {
              grid.innerHTML = '<p class="empty">No products found in this category.</p>';
              total = 0;
            }
            page = p;
            sync();
            return;
          }

          var frag = document.createDocumentFragment();
          for (var i = 0; i < cards.length; i++) {
            var node = document.importNode(cards[i], true);
            node.classList.add('lm-new');
            frag.appendChild(node);
          }
          grid.appendChild(frag);
          page = p;

          // adhoora batch = yeh aakhri page tha
          if (size && cards.length < size) total = count();
          if (txt) txt.textContent = 'Load More';
          sync();
        })
        .catch(function(){
          if (btn) btn.classList.add('is-error');
          if (txt) txt.textContent = 'Try again';
          if (replace) grid.classList.remove('is-swapping');
        })
        .then(done);
    }

    if (btn) {
      btn.addEventListener('click', function(e){
        e.preventDefault();
        load(page + 1, false);
      });
    }

    chips.forEach(function(chip){
      chip.addEventListener('click', function(e){
        if (busy) { e.preventDefault(); return; }
        e.preventDefault();
        chips.forEach(function(c){
          var on = (c === chip);
          c.classList.toggle('is-active', on);
          if (on) { c.setAttribute('aria-current', 'true'); }
          else { c.removeAttribute('aria-current'); }
        });
        base  = chip.dataset.lmBase || chip.getAttribute('href') || '/';
        total = 0;
        load(1, true);
      });
    });

    sync();
  });


  // ---- Sale countdown ----
  // End waqt server se UNIX timestamp ke tor par aata hai (data-end-ts), is liye
  // timezone parsing ka koi masla nahi. Auto-reset on ho to timer khatam hone par
  // agle cycle par khud reset ho jata hai.
  document.querySelectorAll('[data-sale-countdown]').forEach(function(el){
    var ts = parseInt(el.getAttribute('data-end-ts') || '0', 10);
    var end = ts > 0 ? ts * 1000 : NaN;

    // purana format (date string) bhi chalta rahe
    if (!end || isNaN(end)) {
      var raw = (el.getAttribute('data-end') || '').trim().replace(' ', 'T');
      end = new Date(raw).getTime();
    }
    if (!end || isNaN(end)) { el.parentNode && el.parentNode.removeChild(el); return; }

    var resetHours = parseFloat(el.getAttribute('data-auto-reset') || '0');
    var cycleMs = resetHours > 0 ? resetHours * 3600 * 1000 : 0;

    var d = el.querySelector('[data-sd]'), h = el.querySelector('[data-sh]'),
        m = el.querySelector('[data-sm]'), s = el.querySelector('[data-ss]');
    if (!d || !h || !m || !s) return;

    var timer = null;
    function pad(x){ return String(x).padStart(2, '0'); }

    function tick(){
      var diff = Math.floor((end - Date.now()) / 1000);

      if (diff <= 0) {
        if (cycleMs > 0) {
          // auto reset: agla cycle shuru
          var behind = Date.now() - end;
          var steps = Math.floor(behind / cycleMs) + 1;
          end += steps * cycleMs;
          el.classList.add('is-reset');
          setTimeout(function(){ el.classList.remove('is-reset'); }, 600);
          diff = Math.floor((end - Date.now()) / 1000);
        } else {
          if (timer) clearInterval(timer);
          el.classList.add('is-over');
          el.innerHTML = '<span class="st-label">Sale has ended</span>';
          return;
        }
      }

      d.textContent = pad(Math.floor(diff / 86400));
      h.textContent = pad(Math.floor((diff % 86400) / 3600));
      m.textContent = pad(Math.floor((diff % 3600) / 60));
      s.textContent = pad(diff % 60);
    }

    tick();
    timer = setInterval(tick, 1000);
  });


  // ---- Order celebration (Congratulations + confetti) ----
  (function(){
    var box = document.getElementById('orderCelebrate');
    if (!box) return;

    var key = 'lkm-celebrated-' + (box.getAttribute('data-order-key') || '');
    try { if (localStorage.getItem(key)) return; } catch (e) {}   // har order par ek hi baar

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    box.hidden = false;
    document.body.classList.add('no-scroll');
    try { localStorage.setItem(key, '1'); } catch (e) {}

    function close(){
      box.classList.add('is-closing');
      document.body.classList.remove('no-scroll');
      setTimeout(function(){ box.parentNode && box.parentNode.removeChild(box); }, 220);
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e){ if (e.key === 'Escape') close(); }

    box.querySelectorAll('.oc-close, .oc-dismiss').forEach(function(b){ b.addEventListener('click', close); });
    box.addEventListener('click', function(e){ if (e.target === box) close(); });
    document.addEventListener('keydown', onKey);

    var closeBtn = box.querySelector('.oc-close');
    if (closeBtn) closeBtn.focus();

    if (reduced) return;   // motion band ho to sirf popup

    // ---- confetti cannons ----
    // Do cannon: upar BAAYEN aur upar DAAYEN kone se. Har particle ko initial
    // velocity + angle milta hai, phir gravity/drag lagti hai — bilkul asli
    // confetti popper ki tarah arc banta hai, seedha neeche girne ke bajaye.
    var layer = box.querySelector('.oc-confetti');
    if (!layer) return;

    var imgs = [];
    var data = document.getElementById('ocConfettiData');
    if (data) { try { imgs = JSON.parse(data.textContent) || []; } catch (e) { imgs = []; } }

    var colors = ['#ffc801', '#e4002b', '#232f3e', '#22a95c', '#3a86ff', '#ff7b00'];
    var W = window.innerWidth, H = window.innerHeight;
    var small = W < 600;
    var GRAV = 0.34, DRAG = 0.985;

    var parts = [];
    var imgEvery = 4;          // har 4th particle product image
    var imgUsed = 0;

    function spawn(side, count, power) {
      for (var i = 0; i < count; i++) {
        var useImg = imgs.length && (i % imgEvery === 0);
        var el = document.createElement(useImg ? 'img' : 'span');
        el.className = 'oc-bit' + (useImg ? ' oc-bit--img' : '');
        if (useImg) {
          el.src = imgs[imgUsed++ % imgs.length];
          el.alt = '';
          el.loading = 'lazy';
        } else {
          el.style.background = colors[i % colors.length];
          if (i % 5 === 0) el.style.borderRadius = '50%';
          if (i % 3 === 0) el.style.height = '9px';
        }

        // 15deg se 75deg neeche ki taraf — kone se andar ki jaanib fan
        var ang = (15 + Math.random() * 60) * Math.PI / 180;
        var speed = (small ? 11 : 15) * power * (0.65 + Math.random() * 0.7);
        var dir = side === 'left' ? 1 : -1;

        var p = {
          el: el,
          x: side === 'left' ? -10 : W + 10,
          y: -10 + Math.random() * 24,
          vx: dir * Math.cos(ang) * speed,
          vy: Math.sin(ang) * speed * 0.55,
          rot: Math.random() * 360,
          vrot: (Math.random() * 18 - 9),
          tilt: Math.random() * 360,
          vtilt: (Math.random() * 12 - 6),
          sway: 0.4 + Math.random() * 0.9,
          seed: Math.random() * Math.PI * 2
        };
        parts.push(p);
        layer.appendChild(el);
      }
    }

    var base = small ? 16 : 26;
    spawn('left', base, 1);
    spawn('right', base, 1);
    // doosra chhota burst — ek hi dafa mein sab girne se zyada natural lagta hai
    setTimeout(function(){ if (layer.isConnected) { spawn('left', Math.round(base * 0.5), 0.82); spawn('right', Math.round(base * 0.5), 0.82); } }, 220);

    var t0 = performance.now(), raf = null;
    function frame(now) {
      var alive = 0;
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        if (p.dead) continue;

        p.vy += GRAV;
        p.vx *= DRAG;
        p.vy *= DRAG;
        p.x += p.vx + Math.sin((now / 220) + p.seed) * p.sway;   // kaghaz ka flutter
        p.y += p.vy;
        p.rot += p.vrot;
        p.tilt += p.vtilt;

        if (p.y > H + 80 || p.x < -140 || p.x > W + 140) {
          p.dead = true;
          if (p.el.parentNode) p.el.parentNode.removeChild(p.el);
          continue;
        }
        alive++;
        p.el.style.transform = 'translate3d(' + p.x.toFixed(1) + 'px,' + p.y.toFixed(1) + 'px,0) rotate(' + p.rot.toFixed(0) + 'deg) rotateY(' + p.tilt.toFixed(0) + 'deg)';
      }

      if (alive > 0 && now - t0 < 9000) raf = requestAnimationFrame(frame);
      else { if (raf) cancelAnimationFrame(raf); if (layer.parentNode) layer.innerHTML = ''; }
    }
    raf = requestAnimationFrame(frame);

    window.addEventListener('resize', function(){ W = window.innerWidth; H = window.innerHeight; }, { passive: true });
  })();

})();
